/* eslint-disable eqeqeq */
import generateVersionHash from '@utils/generateVersionHash';
import axios from 'axios';
import api from './constants';
import mutations from './mutations';
import state from './state';
import { postApi } from '../../../../lib/fetcher';


const auditTrailAdmin = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      const URL_API = api.GET_LIST_AUDIT_TRAIL_PORTAL_ADMIN;

      try {
        if (ctx.state.requestData) ctx.state.requestData.cancel();

        const axiosSource = axios.CancelToken.source();

        ctx.commit('setCancelation', {
          cancel: axiosSource.cancel,
          msg: 'Loading...',
        });

        ctx.commit('clearData');
        ctx.commit('setLoading', true);
     
        const version = generateVersionHash(page.toString() + itemsPerPage.toString(), date);
        const data = JSON.stringify({
          page: page.toString(),
          limit: itemsPerPage.toString(),
          search,
          version
        });

        const addConfig = { cancelToken: axiosSource.token };

        const responseData = await postApi(ctx, URL_API, data, addConfig);

        if (responseData?.code == 200) {
          ctx.commit('setTotalData', { payload: responseData });
          ctx.commit('setData', { payload: responseData });
        } 
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },
};

export default auditTrailAdmin;
